import { Injectable } from '@angular/core';
import { ParameterFromServicing, ParameterToServicing, SESSION_STORAGE_KEY_FROM_SERVICING } from '../../interface';
import { environment } from '@env/environment';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { PostJourneysGetJourneyResponseDataTravelersInner } from 'src/sdk_checkin';
import { CheckinCommonStoreService } from '../checkin-common-store/checkin-common-store.service';
import { CONNECTION_KIND_OTHER_SPA_TRANSITION } from '@conf';

@Injectable({
  providedIn: 'root',
})
export class ServicingMybookingTransitionService {
  constructor(private checkinCommon: CheckinCommonStoreService) {}

  /**
   * 予約詳細から連携されるパラメータを取得する
   * @returns パラメータが取得でき必須パラメータが揃っている場合にはパラメータ、そうでない場合にはundefined
   */
  getParameterFromServicing(): ParameterFromServicing | undefined {
    // サービシングから受け取るパラメータをセッションストレージから取得
    const rawParams = sessionStorage.getItem(SESSION_STORAGE_KEY_FROM_SERVICING);
    if (rawParams) {
      // セッションストレージから取り出した際は文字列なので、オブジェクトに変換する
      const json = JSON.parse(rawParams) as ParameterFromServicing;
      // 必須パラメータチェック
      if (json?.journeyID && json?.SITE_ID) {
        return json;
      }
    }

    return undefined;
  }

  /**
   * パラメータの設定を行い、URLを書き換えて予約詳細に遷移する
   * @param param 遷移先に渡すパラメータ
   * @param path 遷移先URL
   */
  transitionToServicing(param: ParameterToServicing) {
    const form = document.createElement('form');
    form.action = this.getServicingPathWithConnectionKind();
    form.method = 'POST';
    document.body.append(form);
    form.addEventListener('formdata', (event) => {
      const formData = event.formData;
      Object.entries(param).forEach(([key, value]) => {
        formData.set(key, value);
      });
    });
    form.submit();
  }

  /**
   * 予約詳細へのパスを組み立てて返す
   * @returns 予約詳細へのパス
   */
  getServicingPath() {
    return `${environment.spa.baseUrl}${environment.spa.app.srv}/${SERVICING_ROUTES.bookingSearch}`;
  }

  /**
   * 予約詳細へのパスをCONNECTION_KIND付きで返却する
   * @returns クエリパラメータとして別SPAまたぎのCONNECTION_KINDの値が付与された予約詳細へのパス
   */
  getServicingPathWithConnectionKind() {
    return `${this.getServicingPath()}?${CONNECTION_KIND_OTHER_SPA_TRANSITION.key}=${
      CONNECTION_KIND_OTHER_SPA_TRANSITION.value
    }`;
  }

  /**
   * 予約詳細画面に遷移する際のパラメータの搭乗者情報を組み立てて返却する
   * @param travelers 予約詳細画面へ渡す搭乗者情報を作成するための搭乗者リスト
   * @returns 全ての搭乗者の姓と名を'/'で結合し、それぞれの搭乗者を','で結合した文字列
   */
  concatTravelerNames(travelers: PostJourneysGetJourneyResponseDataTravelersInner[]) {
    return travelers.map((traveler) => traveler.name?.firstName + '/' + traveler.name?.lastName).join(',');
  }

  /**
   * サービシングから遷移してきた場合のパラメータを削除する
   * またチェックイン共通にて格納されているサービシングからの遷移かどうかのパラメータも削除する
   */
  clearFromServicingParameter() {
    sessionStorage.removeItem(SESSION_STORAGE_KEY_FROM_SERVICING);
    this.checkinCommon.updateCheckinCommon({
      reservationDetailIdentifier: undefined,
    });
  }
}
